module.exports = __webpack_public_path__ + "static/media/image_49.a77bd9d0.png";